import React, { useState } from 'react';
import CustomInput from '../components/CustomInput';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import "../Css/login.css";
import BASEURL from '../API/Config';
import { motion } from "framer-motion";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  localStorage.clear();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = {};
    if (!email) validationErrors.email = 'Please enter your email.';
    if (!password) validationErrors.password = 'Please enter your password.';

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: Object.values(validationErrors).join(' '),
        background: '#fff',
        confirmButtonColor: '#e73c7e',
        color: '#333'
      });
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      const response = await fetch(`${BASEURL}/user/admin-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        // Store full user info from login response
        const fullName = `${data.firstname || ''} ${data.lastname || ''}`.trim();
        localStorage.setItem('UserName', fullName || data.Username || 'Admin');
        localStorage.setItem('UserEmail', data.email || '');
        localStorage.setItem('UserFirstName', data.firstname || '');
        localStorage.setItem('UserLastName', data.lastname || '');
        localStorage.setItem('Role', data.role || 'Administrator');
        navigate('/admin');
      } else {
        const errorData = await response.json();
        setErrors({ form: errorData.message || 'Invalid credentials. Please try again.' });
      }
    } catch (error) {
      setErrors({ form: 'Something went wrong. Please try again later.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-container'>
      <motion.div 
        className='login-box'
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h3>Welcome Back</h3>
        <p>Login to your admin account</p>
        
        <form onSubmit={handleSubmit}>
          <div className="custom-input-group">
            <CustomInput
              type="email"
              label="Email Address"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <p className="error-text">{errors.email}</p>}
          </div>

          <div className="custom-input-group">
            <CustomInput
              type="password"
              label="Password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {errors.password && <p className="error-text">{errors.password}</p>}
          </div>

          <button className='login-button' type='submit' disabled={loading}>
            {loading ? <div className="loader"></div> : 'Login to Account'}
          </button>
          
          {errors.form && <p className="error-text mt-3">{errors.form}</p>}

          <Link to="/forget-password" title="Forget-password" className='forget-link'>
            Forgot password?
          </Link>
        </form>
      </motion.div>
    </div>
  );
};

export default Login;

